import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { registerAlgoCommandListener } from '@/store/orders/algoOrders/listener.ts';
import { registerOptimisticOrderListener } from '@/store/orders/listeners/optimisticOrderListener.ts';

export function registerOrderListeners(startAppListening: StartAppListening): void {
  registerAlgoCommandListener(startAppListening);
  registerOptimisticOrderListener(startAppListening);
}
